module.exports = __webpack_public_path__ + "img/send_button.503cde5b.png";